import { useHelperStore } from '@/store/helperStore';

export function calculateTarif(context, tarifId) {
  const result = {
    name: 'unkown',
    price: null,
    implemented: false,
  };

  const tarif = useHelperStore().tarifs.find((item) => item.ID == tarifId);

  if (tarif) {
    result.name = tarif.NAME;
    // fixed
    if (tarif.CALCULATION_TYPE == 0) {
      result.price = tarif.FIXED_FEE_AMOUNT;
      result.currency = tarif.CURRENCY_CODE;
      result.implemented = true;
    }
  }

  return result;
}
